import { simpleFetch } from "./acCommon"


export const FETCH_AREAPARTNERS_REQUEST = "FETCH_AREAPARTNERS_REQUEST"
export const FETCH_AREAPARTNERS_SUCCESS = "FETCH_AREAPARTNERS_SUCCESS"
export const FETCH_AREAPARTNERS_FAILURE = "FETCH_AREAPARTNERS_FAILURE"

export const SUBMIT_ASK_FOR_ZIP_CODE_REQUEST = "SUBMIT_ASK_FOR_ZIP_CODE_REQUEST"
export const SUBMIT_ASK_FOR_ZIP_CODE_SUCCESS = "SUBMIT_ASK_FOR_ZIP_CODE_SUCCESS"
export const SUBMIT_ASK_FOR_ZIP_CODE_FAILURE = "SUBMIT_ASK_FOR_ZIP_CODE_FAILURE"

export const fetchAreaPartners = area => (dispatch, getState) => {
	let init = { method: 'GET' }
	let url = "/customers/affiliates?zip_code=" + area
	dispatch(simpleFetch(url, init, 'FETCH_AREAPARTNERS'))
}



// WEBPACK FOOTER //
// ./src/actions/acLanding.js